import React from 'react';

export const FlagWarningIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_8473_11142)">
        <path
          d="M52.8001 31.7697L44.8801 21.9897L52.8001 12.2097C54.1801 10.4997 54.4501 8.18973 53.5201 6.20973C52.5901 4.22973 50.6101 2.96973 48.3901 2.96973H11.3101C8.19014 2.96973 5.64014 5.51973 5.64014 8.63973V53.9697C5.64014 55.6197 6.99014 56.9697 8.64014 56.9697C10.2901 56.9697 11.6401 55.6197 11.6401 53.9697V40.9797H48.3901C50.6101 40.9797 52.5601 39.7497 53.5201 37.7397C54.4801 35.7597 54.2101 33.4497 52.8001 31.7397V31.7697ZM11.6401 35.0097V8.99973H47.6701L38.6701 20.0997C37.7701 21.2097 37.7701 22.7697 38.6701 23.8797L47.6701 34.9797H11.6401V35.0097Z"
          fill="#FF6711"
        />
      </g>
      <defs>
        <clipPath id="clip0_8473_11142">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
